import { styled } from "@mui/material";
import {
  type GridRenderCellParams,
  type GridColDef,
} from "@mui/x-data-grid-pro";
import { DataGrid } from "./DataGrid";
import {
  type ToolbarProps,
  MonitoringDetailReceptionBookToolbar,
} from "./MonitoringDetailReceptionBookToolbar";
import { useGridPagination } from "../hooks/useGridPagination";
import { type MonitoringDetailReceptionBookRow } from "../types";
import { format } from "date-fns";

interface IProps {
  rows: MonitoringDetailReceptionBookRow[];
}

const StyledDataGrid = styled(DataGrid)`
  // テーブルのセルをクリックしても青い枠が表示されないようにする
  & .MuiDataGrid-cell:focus-within,
  & .MuiDataGrid-cell:focus {
    outline: none !important;
  }

  // テーブルのカラムヘッダをクリックしても青い枠が表示されないようにする
  & .MuiDataGrid-columnHeader:focus-within,
  & .MuiDataGrid-columnHeader:focus {
    outline: none !important;
  }

  // テーブルヘッダーの背景色を設定
  .MuiDataGrid-columnHeaders {
    line-height: 1.5em !important;
  }

  // テーブルタイトルを太字に
  .MuiDataGrid-columnHeaderTitle {
    font-weight: 700;
  }
`;

const makeGridColDef = (): GridColDef[] => {
  return [
    {
      field: "legalAffairsBureauRequestDate",
      headerName: "法務局受付日",
      width: 180,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ value }: GridRenderCellParams<string>) => {
        if (value != null) return format(new Date(value), "yyyy/MM/dd");
      },
    },
    {
      field: "receptionReason",
      headerName: "登記原因",
      width: 200,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "soto",
      headerName: "外",
      width: 50,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
  ];
};

export const MonitoringDetailReceptionBookDataGrid: React.FC<IProps> = (
  props: IProps
) => {
  const { rows } = props;
  const { page, pageSize, changePage, changePageSize } = useGridPagination();
  const rowsPerPageOptions: number[] = [25, 50, 100];
  const colDef = makeGridColDef();

  const dataGridPaginationProps = {
    page,
    pageSize,
    rowsPerPageOptions,
    onPageChange: changePage,
    onPageSizeChange: changePageSize,
  };

  const toolbarProps: ToolbarProps = {
    page,
    pageSize,
    rowsPerPageOptions,
    changePage,
    changePageSize,
    allCount: rows.length,
  };

  return (
    <StyledDataGrid
      stickyHeader={true}
      autoHeight
      columns={colDef}
      disableColumnMenu
      disableSelectionOnClick={true}
      rows={rows}
      {...dataGridPaginationProps}
      components={{
        Toolbar: MonitoringDetailReceptionBookToolbar,
      }}
      componentsProps={{
        toolbar: {
          ...toolbarProps,
        },
      }}
    />
  );
};
